import EventEmitter from "../../utils/eventEmitter";
import Axios from "../../utils/axios";


export const loadUsers = async () => {
  try {
    const response = await Axios.get('users');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};



export const loadUser = async (action) => {
  try {
    switch (action) {
      case 'new':
        const response = await Axios.get('users/setup');
        const requestData = await response.data;
        return {...requestData, user: {}};
        
      default:
        const respnse = await Axios.get('users/find/'+action);
        const responseData = await respnse.data;
        return responseData;
    }
  }catch (err) {
    throw err;
  }
}

const useUserAPI = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('users', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('user_response', responseData.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('users/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('user_response', responseData.seo);
    }catch (err) {
      throw err;
    }
  }


  return { create, update };
};



export default useUserAPI;


